import React, { useState } from "react";
import NoticeCard from "./NoticeCard";
import { Button, notification, Popover, Spin } from "antd";
import StopConfirmationContent from "./StopConfirmationContent";
import BinApiService from "src/api/BinApiService";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";

interface ReconditioningOperationsCardProps{
    binDto: PremierPlusBinDTO | null;
    handleShowReconditioningSettingsModal: () => void;
    handleClickViewReconditioning: () => void;
}

const ReconditioningOperationsCard = ({ binDto, handleShowReconditioningSettingsModal, handleClickViewReconditioning }: ReconditioningOperationsCardProps) => {

    const [isSpinning, setIsSpinning] = useState(false);
    const [sequencedReconditioningStopPopoverOpen, setSequencedReconditioningStopOpen] = useState(false);
    const [stopReconditioningPopoverOpen, setStopReconditioningPopoverOpen] = useState(false);

    const onClickYesStopReconditioning = async () => {
      try{
        await BinApiService.premierPlus_StopReconditioningOperation(binDto?.binId ?? 0, true);
        notification.success({ message: 'Reconditioning stopped successfully' });
      }catch(err){
        console.error('Error stopping reconditioning:', err);
        notification.error({ message: 'Error stopping reconditioning', description: 'Please try again later.' });
      }finally{
      }

      setStopReconditioningPopoverOpen(false);
    }

    const onClickNoStopReconditioning = () => {
      setStopReconditioningPopoverOpen(false);
    }

    const onClickYesSequencedReconditioningStop = async () => {
        try{
            setIsSpinning(true);
            await BinApiService.premierPlus_StopReconditioningOperation(binDto?.binId ?? 0, false);
            notification.success({ message: 'Reconditioning stopped successfully' });
        }catch(err){
            console.error('Error stopping reconditioning:', err);
            notification.error({ message: 'Error stopping reconditioning', description: 'Please try again later.' });
        }finally{
            setIsSpinning(false);
        }

        setSequencedReconditioningStopOpen(false);
    }

    const onClickNoSequencedReconditioningStop = () => {
      setSequencedReconditioningStopOpen(false);
    }

    return(
        <NoticeCard
        title="Reconditioning is running"
        description="Automated reconditioning operations are currently active"
        buttons={
            <>
                <Popover
                open={sequencedReconditioningStopPopoverOpen}
                trigger="click"
                onOpenChange={(newOpen) => {
                    if (!newOpen) setSequencedReconditioningStopOpen(false);
                }}
                content={
                    <Spin spinning={isSpinning}>
                        <StopConfirmationContent
                        message="Are you sure you want to stop reconditioning operations?"
                        onConfirm={onClickYesSequencedReconditioningStop}
                        onCancel={onClickNoSequencedReconditioningStop}
                        />
                    </Spin>
                }
                >
                    <Button type="primary" danger onClick={() => setSequencedReconditioningStopOpen(true)}>
                        Sequenced Reconditioning Stop
                    </Button>
                </Popover>

                <Popover
                open={stopReconditioningPopoverOpen}
                trigger="click"
                onOpenChange={(newOpen) => {
                    if (!newOpen) setStopReconditioningPopoverOpen(false);
                }}
                content={
                    <Spin spinning={isSpinning}>
                        <StopConfirmationContent
                        message="Are you sure you want to stop reconditioning operations?"
                        onConfirm={onClickYesStopReconditioning}
                        onCancel={onClickNoStopReconditioning}
                        />
                    </Spin>
                }
                >
                    <Button type="primary" danger onClick={() => setStopReconditioningPopoverOpen(true)}>
                    Stop All
                    </Button>
                </Popover>

                <Button type="primary" onClick={handleShowReconditioningSettingsModal}>
                    Change Settings
                </Button>

                <Button type="primary" onClick={handleClickViewReconditioning}>
                    View HMI
                </Button>
            </>
        }
        />
    )
}

export default ReconditioningOperationsCard;
